import _toConsumableArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { ContextualKeyword } from "../parser/tokenizer/keywords";
import { TokenType as tt } from "../parser/tokenizer/types";
import getClassInfo from "../util/getClassInfo";
import CJSImportTransformer from "./CJSImportTransformer";
import ESMImportTransformer from "./ESMImportTransformer";
import FlowTransformer from "./FlowTransformer";
import JestHoistTransformer from "./JestHoistTransformer";
import JSXTransformer from "./JSXTransformer";
import NumericSeparatorTransformer from "./NumericSeparatorTransformer";
import OptionalCatchBindingTransformer from "./OptionalCatchBindingTransformer";
import OptionalChainingNullishTransformer from "./OptionalChainingNullishTransformer";
import ReactDisplayNameTransformer from "./ReactDisplayNameTransformer";
import ReactHotLoaderTransformer from "./ReactHotLoaderTransformer";
import TypeScriptTransformer from "./TypeScriptTransformer";

var RootTransformer = /*#__PURE__*/function () {
  function RootTransformer(sucraseContext, transforms, enableLegacyBabel5ModuleInterop, options) {
    _classCallCheck(this, RootTransformer);

    ;

    RootTransformer.prototype.__init.call(this);

    RootTransformer.prototype.__init2.call(this);

    this.nameManager = sucraseContext.nameManager;
    this.helperManager = sucraseContext.helperManager;
    var tokenProcessor = sucraseContext.tokenProcessor,
        importProcessor = sucraseContext.importProcessor;
    this.tokens = tokenProcessor;
    this.isImportsTransformEnabled = transforms.includes("imports");
    this.isReactHotLoaderTransformEnabled = transforms.includes("react-hot-loader");
    this.disableESTransforms = Boolean(options.disableESTransforms);

    if (!options.disableESTransforms) {
      this.transformers.push(new OptionalChainingNullishTransformer(tokenProcessor, this.nameManager));
      this.transformers.push(new NumericSeparatorTransformer(tokenProcessor));
      this.transformers.push(new OptionalCatchBindingTransformer(tokenProcessor, this.nameManager));
    }

    if (transforms.includes("jsx")) {
      if (options.jsxRuntime !== "preserve") {
        this.transformers.push(new JSXTransformer(this, tokenProcessor, importProcessor, this.nameManager, options));
      }

      this.transformers.push(new ReactDisplayNameTransformer(this, tokenProcessor, importProcessor, options));
    }

    var reactHotLoaderTransformer = null;

    if (transforms.includes("react-hot-loader")) {
      if (!options.filePath) {
        throw new Error("filePath is required when using the react-hot-loader transform.");
      }

      reactHotLoaderTransformer = new ReactHotLoaderTransformer(tokenProcessor, options.filePath);
      this.transformers.push(reactHotLoaderTransformer);
    } // Note that we always want to enable the imports transformer, even when the import transform
    // itself isn't enabled, since we need to do type-only import pruning for both Flow and
    // TypeScript.


    if (transforms.includes("imports")) {
      if (importProcessor === null) {
        throw new Error("Expected non-null importProcessor with imports transform enabled.");
      }

      this.transformers.push(new CJSImportTransformer(this, tokenProcessor, importProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, Boolean(options.enableLegacyTypeScriptModuleInterop), transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.preserveDynamicImport), Boolean(options.keepUnusedImports)));
    } else {
      this.transformers.push(new ESMImportTransformer(tokenProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.keepUnusedImports), options));
    }

    if (transforms.includes("flow")) {
      this.transformers.push(new FlowTransformer(this, tokenProcessor, transforms.includes("imports")));
    }

    if (transforms.includes("typescript")) {
      this.transformers.push(new TypeScriptTransformer(this, tokenProcessor, transforms.includes("imports")));
    }

    if (transforms.includes("jest")) {
      this.transformers.push(new JestHoistTransformer(this, tokenProcessor, this.nameManager, importProcessor));
    }
  }

  _createClass(RootTransformer, [{
    key: "__init",
    value: function __init() {
      this.transformers = [];
    }
  }, {
    key: "__init2",
    value: function __init2() {
      this.generatedVariables = [];
    }
  }, {
    key: "transform",
    value: function transform() {
      this.tokens.reset();
      this.processBalancedCode();
      var shouldAddUseStrict = this.isImportsTransformEnabled; // "use strict" always needs to be first, so override the normal transformer order.

      var prefix = shouldAddUseStrict ? '"use strict";' : "";

      var _iterator = _createForOfIteratorHelper(this.transformers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var transformer = _step.value;
          prefix += transformer.getPrefixCode();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      prefix += this.helperManager.emitHelpers();
      prefix += this.generatedVariables.map(function (v) {
        return " var ".concat(v, ";");
      }).join("");

      var _iterator2 = _createForOfIteratorHelper(this.transformers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _transformer = _step2.value;
          prefix += _transformer.getHoistedCode();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var suffix = "";

      var _iterator3 = _createForOfIteratorHelper(this.transformers),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _transformer2 = _step3.value;
          suffix += _transformer2.getSuffixCode();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var result = this.tokens.finish();
      var code = result.code;

      if (code.startsWith("#!")) {
        var newlineIndex = code.indexOf("\n");

        if (newlineIndex === -1) {
          newlineIndex = code.length;
          code += "\n";
        }

        return {
          code: code.slice(0, newlineIndex + 1) + prefix + code.slice(newlineIndex + 1) + suffix,
          // The hashbang line has no tokens, so shifting the tokens to account
          // for prefix can happen normally.
          mappings: this.shiftMappings(result.mappings, prefix.length)
        };
      } else {
        return {
          code: prefix + code + suffix,
          mappings: this.shiftMappings(result.mappings, prefix.length)
        };
      }
    }
  }, {
    key: "processBalancedCode",
    value: function processBalancedCode() {
      var braceDepth = 0;
      var parenDepth = 0;

      while (!this.tokens.isAtEnd()) {
        if (this.tokens.matches1(tt.braceL) || this.tokens.matches1(tt.dollarBraceL)) {
          braceDepth++;
        } else if (this.tokens.matches1(tt.braceR)) {
          if (braceDepth === 0) {
            return;
          }

          braceDepth--;
        }

        if (this.tokens.matches1(tt.parenL)) {
          parenDepth++;
        } else if (this.tokens.matches1(tt.parenR)) {
          if (parenDepth === 0) {
            return;
          }

          parenDepth--;
        }

        this.processToken();
      }
    }
  }, {
    key: "processToken",
    value: function processToken() {
      if (this.tokens.matches1(tt._class)) {
        this.processClass();
        return;
      }

      var _iterator4 = _createForOfIteratorHelper(this.transformers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var transformer = _step4.value;
          var wasProcessed = transformer.process();

          if (wasProcessed) {
            return;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      this.tokens.copyToken();
    }
    /**
     * Skip past a class with a name and return that name.
     */

  }, {
    key: "processNamedClass",
    value: function processNamedClass() {
      if (!this.tokens.matches2(tt._class, tt.name)) {
        throw new Error("Expected identifier for exported class name.");
      }

      var name = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
      this.processClass();
      return name;
    }
  }, {
    key: "processClass",
    value: function processClass() {
      var classInfo = getClassInfo(this, this.tokens, this.nameManager, this.disableESTransforms); // Both static and instance initializers need a class name to use to invoke the initializer, so
      // assign to one if necessary.

      var needsCommaExpression = (classInfo.headerInfo.isExpression || !classInfo.headerInfo.className) && classInfo.staticInitializerNames.length + classInfo.instanceInitializerNames.length > 0;
      var className = classInfo.headerInfo.className;

      if (needsCommaExpression) {
        className = this.nameManager.claimFreeName("_class");
        this.generatedVariables.push(className);
        this.tokens.appendCode(" (".concat(className, " ="));
      }

      var classToken = this.tokens.currentToken();
      var contextId = classToken.contextId;

      if (contextId == null) {
        throw new Error("Expected class to have a context ID.");
      }

      this.tokens.copyExpectedToken(tt._class);

      while (!this.tokens.matchesContextIdAndLabel(tt.braceL, contextId)) {
        this.processToken();
      }

      this.processClassBody(classInfo, className);
      var staticInitializerStatements = classInfo.staticInitializerNames.map(function (name) {
        return "".concat(className, ".").concat(name, "()");
      });

      if (needsCommaExpression) {
        this.tokens.appendCode(", ".concat(staticInitializerStatements.map(function (s) {
          return "".concat(s, ", ");
        }).join("")).concat(className, ")"));
      } else if (classInfo.staticInitializerNames.length > 0) {
        this.tokens.appendCode(" ".concat(staticInitializerStatements.map(function (s) {
          return "".concat(s, ";");
        }).join(" ")));
      }
    }
    /**
     * We want to just handle class fields in all contexts, since TypeScript supports them. Later,
     * when some JS implementations support class fields, this should be made optional.
     */

  }, {
    key: "processClassBody",
    value: function processClassBody(classInfo, className) {
      var headerInfo = classInfo.headerInfo,
          constructorInsertPos = classInfo.constructorInsertPos,
          constructorInitializerStatements = classInfo.constructorInitializerStatements,
          fields = classInfo.fields,
          instanceInitializerNames = classInfo.instanceInitializerNames,
          rangesToRemove = classInfo.rangesToRemove;
      var fieldIndex = 0;
      var rangeToRemoveIndex = 0;
      var classContextId = this.tokens.currentToken().contextId;

      if (classContextId == null) {
        throw new Error("Expected non-null context ID on class.");
      }

      this.tokens.copyExpectedToken(tt.braceL);

      if (this.isReactHotLoaderTransformEnabled) {
        this.tokens.appendCode("__reactstandin__regenerateByEval(key, code) {this[key] = eval(code);}");
      }

      var needsConstructorInit = constructorInitializerStatements.length + instanceInitializerNames.length > 0;

      if (constructorInsertPos === null && needsConstructorInit) {
        var constructorInitializersCode = this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className);

        if (headerInfo.hasSuperclass) {
          var argsName = this.nameManager.claimFreeName("args");
          this.tokens.appendCode("constructor(...".concat(argsName, ") { super(...").concat(argsName, "); ").concat(constructorInitializersCode, "; }"));
        } else {
          this.tokens.appendCode("constructor() { ".concat(constructorInitializersCode, "; }"));
        }
      }

      while (!this.tokens.matchesContextIdAndLabel(tt.braceR, classContextId)) {
        if (fieldIndex < fields.length && this.tokens.currentIndex() === fields[fieldIndex].start) {
          var needsCloseBrace = false;

          if (this.tokens.matches1(tt.bracketL)) {
            this.tokens.copyTokenWithPrefix("".concat(fields[fieldIndex].initializerName, "() {this"));
          } else if (this.tokens.matches1(tt.string) || this.tokens.matches1(tt.num)) {
            this.tokens.copyTokenWithPrefix("".concat(fields[fieldIndex].initializerName, "() {this["));
            needsCloseBrace = true;
          } else {
            this.tokens.copyTokenWithPrefix("".concat(fields[fieldIndex].initializerName, "() {this."));
          }

          while (this.tokens.currentIndex() < fields[fieldIndex].end) {
            if (needsCloseBrace && this.tokens.currentIndex() === fields[fieldIndex].equalsIndex) {
              this.tokens.appendCode("]");
            }

            this.processToken();
          }

          this.tokens.appendCode("}");
          fieldIndex++;
        } else if (rangeToRemoveIndex < rangesToRemove.length && this.tokens.currentIndex() >= rangesToRemove[rangeToRemoveIndex].start) {
          if (this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end) {
            this.tokens.removeInitialToken();
          }

          while (this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end) {
            this.tokens.removeToken();
          }

          rangeToRemoveIndex++;
        } else if (this.tokens.currentIndex() === constructorInsertPos) {
          this.tokens.copyToken();

          if (needsConstructorInit) {
            this.tokens.appendCode(";".concat(this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className), ";"));
          }

          this.processToken();
        } else {
          this.processToken();
        }
      }

      this.tokens.copyExpectedToken(tt.braceR);
    }
  }, {
    key: "makeConstructorInitCode",
    value: function makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className) {
      return [].concat(_toConsumableArray(constructorInitializerStatements), _toConsumableArray(instanceInitializerNames.map(function (name) {
        return "".concat(className, ".prototype.").concat(name, ".call(this)");
      }))).join(";");
    }
    /**
     * Normally it's ok to simply remove type tokens, but we need to be more careful when dealing with
     * arrow function return types since they can confuse the parser. In that case, we want to move
     * the close-paren to the same line as the arrow.
     *
     * See https://github.com/alangpierce/sucrase/issues/391 for more details.
     */

  }, {
    key: "processPossibleArrowParamEnd",
    value: function processPossibleArrowParamEnd() {
      if (this.tokens.matches2(tt.parenR, tt.colon) && this.tokens.tokenAtRelativeIndex(1).isType) {
        var nextNonTypeIndex = this.tokens.currentIndex() + 1; // Look ahead to see if this is an arrow function or something else.

        while (this.tokens.tokens[nextNonTypeIndex].isType) {
          nextNonTypeIndex++;
        }

        if (this.tokens.matches1AtIndex(nextNonTypeIndex, tt.arrow)) {
          this.tokens.removeInitialToken();

          while (this.tokens.currentIndex() < nextNonTypeIndex) {
            this.tokens.removeToken();
          }

          this.tokens.replaceTokenTrimmingLeftWhitespace(") =>");
          return true;
        }
      }

      return false;
    }
    /**
     * An async arrow function might be of the form:
     *
     * async <
     *   T
     * >() => {}
     *
     * in which case, removing the type parameters will cause a syntax error. Detect this case and
     * move the open-paren earlier.
     */

  }, {
    key: "processPossibleAsyncArrowWithTypeParams",
    value: function processPossibleAsyncArrowWithTypeParams() {
      if (!this.tokens.matchesContextual(ContextualKeyword._async) && !this.tokens.matches1(tt._async)) {
        return false;
      }

      var nextToken = this.tokens.tokenAtRelativeIndex(1);

      if (nextToken.type !== tt.lessThan || !nextToken.isType) {
        return false;
      }

      var nextNonTypeIndex = this.tokens.currentIndex() + 1; // Look ahead to see if this is an arrow function or something else.

      while (this.tokens.tokens[nextNonTypeIndex].isType) {
        nextNonTypeIndex++;
      }

      if (this.tokens.matches1AtIndex(nextNonTypeIndex, tt.parenL)) {
        this.tokens.replaceToken("async (");
        this.tokens.removeInitialToken();

        while (this.tokens.currentIndex() < nextNonTypeIndex) {
          this.tokens.removeToken();
        }

        this.tokens.removeToken(); // We ate a ( token, so we need to process the tokens in between and then the ) token so that
        // we remain balanced.

        this.processBalancedCode();
        this.processToken();
        return true;
      }

      return false;
    }
  }, {
    key: "processPossibleTypeRange",
    value: function processPossibleTypeRange() {
      if (this.tokens.currentToken().isType) {
        this.tokens.removeInitialToken();

        while (this.tokens.currentToken().isType) {
          this.tokens.removeToken();
        }

        return true;
      }

      return false;
    }
  }, {
    key: "shiftMappings",
    value: function shiftMappings(mappings, prefixLength) {
      for (var i = 0; i < mappings.length; i++) {
        var mapping = mappings[i];

        if (mapping !== undefined) {
          mappings[i] = mapping + prefixLength;
        }
      }

      return mappings;
    }
  }]);

  return RootTransformer;
}();

export { RootTransformer as default };